module.exports = __webpack_public_path__ + "img/seo.95679989.png";